import { Drawer } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import "./simpledrawer.css";

const SimpleDrawer = ({
  drawerOpen = false,
  setDrawerOpen = () => {},
  placement = "right",
  closable,
  closeIcon,
  width,
  title,
  padding,
  Component = <></>,
  topOffset = 0,
  bottomOffset = 0,
  styles = {},
  clsNames = "",
  mask = true,
  seperatorHeaderAndContent = true,
}) => {
  return (
    <div className="ant-drawer-header" data-title={title} >
      <Drawer
        placement={placement}
        title={<span className="mas-simple-drawer-title">{title ?? ""}</span>}
        closable={closable}
        closeIcon={"closeIcon" ?? <CloseOutlined />}
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
        width={width}
        headerStyle={{
          padding: padding?.head ?? 17,
          borderBottom: seperatorHeaderAndContent ? undefined : "none",
        }}
        bodyStyle={{ padding: padding?.body ?? 17 }}
        style={{
          ...styles,
          marginTop: `${topOffset}px`,
          marginBottom: `${bottomOffset}px`,
          height: `calc(100% - ${Number(topOffset) + Number(bottomOffset)}px)`,
        }}
        mask={mask}
        className={clsNames}
      >
        {Component}
      </Drawer>
    </div>
  );
};

export default SimpleDrawer;
